<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 10:55:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-20 16:30:21
 * @FilePath: 
 * @Description: 选择人数页面
-->
<template>
  <div class="check_person_con">
    <div class="person_title_con">
       <p class="keycode-title-class" >桌台号:{{deskCode}}</p>
       <div style="display: flex;align-items: center;">
          <img src="@/assets/images/point-user.png" alt=""  style="margin-top: 10px;width: 36px;height: 36px;"/>
          
            <p class="c-ft-26" style="color: #737A84;font-size: 14px;margin-left: 8px;">Sunshine</p>

         <p class="c-ft-26" style="color: #555C67;font-size: 16px;margin-left: 8px;font-weight: 500;">欢迎来到店内用餐～</p>
       </div>
     
    </div>
    <div class="select_number_con">
      <div class="table_number_con" v-if="PayMode==2">
           <p class="keycode-title-class" style="font-size: 16px;color: #555C67;">请输入您的手牌号</p>
           <div class="keycode-class" >
          <input class="keycode-input" style="font-weight: 500;font-size: 18px;" v-model="cardCode" /> 
          <img src="@/assets/order/1@2x(3).png" class="keycode-scan" @click="bindingHandNumber" v-if="KeyBindComponent===0">
           </div>
       </div>
      <div class="c-ft-32" style="color: #555C67;font-weight:500;margin-top: 16px;">{{PayMode==2?'请问您几人用餐':'请选择用餐人数'}}</div>
       
       <div style="color: #97A0A9;font-size: 12px;margin-top: 12px;" v-if="PayMode==2">请选择人数</div>
      <ul class="table_number_con" style="margin-top: 16px;">
        <li
          v-for="(item, index) in 12"
          :class="[{ active_item: tableNumber == item }, 'table_number_item']"
          style="font-size: 18px;"
          :key="index"
          @click="onClickTableNumber(item)"
        >
          {{ item }}
        </li>
      </ul>
      <van-field
        v-model="tableNumber"
        type="digit"
        style="border: 1px solid #EAEAEA;border-radius: 40px;font-size: 16px;color: #97A0A9; "
        label=""
        placeholder="填写人数"
      />

       <div style="color: #97A0A9;font-size: 12px;margin-top: 24px;" >若有儿童，请选择儿童数量</div>
      <ul class="table_number_con" style="margin-top: 16px;">
        <li
          v-for="(item, index) in 8"
          :class="[{ active_item: tableChildenNumber == item }, 'table_number_item']"
          style="font-size: 18px;"
          :key="index"
          @click="onClickTableChildenNumber(item)"
        >
          {{ item }}
        </li>
      </ul>
      <van-field
        v-model="tableChildenNumber"
        type="digit"
        style="border: 1px solid #EAEAEA;border-radius: 40px;font-size: 16px;color: #97A0A9; "
        label=""
        placeholder="填写人数"
      />

      <div class="number_submit_btns">
        <van-button
          v-if="fromPage == 'NewPlaceOrder' && !isFromMicropoint"
          color="#E1EDDE"
          block
          round
          class="custom-button"
          @click="handleToOrderPage"
          >确定</van-button
        >
        <van-button
          v-else
          color="#E1EDDE"
          block
          round
          class="custom-button"
          @click="handleToOrderPage"
          >{{ "确定" }}</van-button
        >
      </div>
    </div>

    <van-overlay :show="showSelectModal" z-index="5"
     :style="{
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)'
    }">
      <div class="overlay_con" style="margin-left: 10px;margin-right: 10px;">
      
        <div class="overlay_con_content">
        <p style="text-align: center; height: 60px; line-height: 60px;font-weight: bold;">
          温馨提示
        </p>
        <div style="display: flex">
          <img
           class="overlay_con_img"
            src="@/assets/order/1@2x(6).png"
            alt=""
          />
          <p class="overlay_con_p"  style="font-size: 14px;color: #737A84;">合理点餐，请勿浪费食物～ </p>
          <div style="flex: 1" />
        </div>
        <div style="display: flex">
          <img
            src="@/assets/order/1@2x(7).png"
              class="overlay_con_img"
            alt=""
          />
          <p class="overlay_con_p" style="font-size: 14px;color: #737A84;">未成年人请勿饮酒！</p>
          <div style="flex: 1" />
        </div>

        <div style="margin-left: 40px; margin-right: 40px; margin-top: 30px">
          <van-button
            color="#E1EDDE"
            block
            round
            class="custom-button"
            @click="closedailog"
            >我已知悉</van-button
          >
        </div>
        <div style=" height: 30px;"/>
      </div>
      </div>
      
    </van-overlay>

      <!-- 去掉弹框提示 ，这不是团队点餐，是是否有历史订单提示-->
     <!-- <van-overlay :show="showEnableTeamOrder" z-index="999"
      :style="{
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)'
    }">
      <div class="overlay_con" style="margin-left: 10px;margin-right: 10px;">
        <div class="overlay_con_content">
         <p style="text-align: center; height: 60px; line-height: 60px;font-weight: bold;">
          温馨提示
        </p>
        <p class="overlay_con_p" style="margin-left: 30px;margin-right: 30px;">您好，这张桌子已经有人点过餐，请问您还要继续点餐吗？ </p>
      
        <div style="margin-left: 1rem; margin-right: 1rem; margin-top: 60px;display: flex;">
          <van-button
            color="#E1EDDE"
            block
            round
            class="cancel-custom-button"
            @click="showEnableTeamOrder=false"
            >继续点餐</van-button
          >
          <div style="width: 4rem;"/>
          <van-button
            color="#E1EDDE"
            block
            round
            style="width: 28rem;"
            class="custom-button"
            @click="goToHistouryConsume"
            >查看已点餐品</van-button
          >
        </div>

        <div style=" height: 30px;"/>
      </div>
      </div>
      
    </van-overlay> -->
  </div>
</template>
<script>
import {
  applyBlackGoldenUIVersion,
  applyDevMockUseBlackGoldenUI,
  getBlackInputPeopleNumRouteName,
  handleSessionStorage,
  isBlackOrderFlag,
  setBlackOrderFlag,
} from "@/utils";
import { handleLocalStorage, handleScanCode } from "@/utils";
import {
  getDiningRoomList,
  getFoodList,
  getSetmealFoodInfo,
} from "@/api/foodOrder";
export default {
  name: "NewInputPeopleNum",
  props: {},
  data() {
    return {
      // numValue: "",
      showEnableTeamOrder: false,
      EnableTeamOrder: false, //是否团队点单
      errorMsg: "",
      showSelectModal: true,
      tableNumber: 1,
      tableChildenNumber: '',
      saasCode: "",
      diningRoomId: "",
      vpnInfo: {},
      PayMode: 0,
      deskCode: "",
      cardCode: "",
      KeyBindComponent:0
    };
  },
  components: {},
  created() {
    const queryData = this.$route.query;
    this.fromPage = queryData.fromPage;
    this.saasCode = queryData.saasCode;
    this.diningRoomId = handleSessionStorage.get("diningRoomId");
    this.isFromMicropoint = queryData.isFromMicropoint;
    this.EnableTeamOrder = handleSessionStorage.get("EnableTeamOrder");
    const deskCode = handleSessionStorage.get("deskCode");
    this.deskCode = deskCode && deskCode.code;
    this.cardCode = deskCode && deskCode.cardCode;
    // this.updateEnableTeamOrderDailog();
    this.handleGetVpnList();
    this.redirectToBlackPeopleNumIfNeeded();
  },

  mounted() {},
  methods: {
    redirectToBlackPeopleNumIfNeeded() {
      if (
        isBlackOrderFlag() &&
        this.$route.name !== getBlackInputPeopleNumRouteName()
      ) {
        this.$router.replace({
          name: getBlackInputPeopleNumRouteName(),
          query: this.$route.query,
        });
        return true;
      }
      return false;
    },
    bindingHandNumber() {
      // 调起微信扫码，并执行成功函数
      const NeedResultType = 1;
      handleScanCode({ needResult: NeedResultType }, this.handleScanSuccess);
    },
    handleScanSuccess(res) {
      if (res) {
        const result = res + "";
        const _pString = result.split('?p=')[1];
           this.$router.replace({
            name: "takeNumberResult",
            query: {
              action:'takeorder',
              fromPage: 'NewMicropoint',
              isFromMicropoint: true,
              backUrl:"NewInputPeopleNum",
              vpncode: params.vpncode,
              p:_pString,
            },
          });
      }
    },
    /**查看消费*/
    goToHistouryConsume() {
      this.showEnableTeamOrder = false;
       this.$router.push({
        name: "MicropointCurrentConsume",
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
    /**关闭不要浪费粮食弹窗*/
    closedailog() {
      this.showSelectModal = false;
      // this.updateEnableTeamOrderDailog();
    },
    /**是否显示团队点单 提示窗口*/
    updateEnableTeamOrderDailog() {
      if (this.EnableTeamOrder) {
        this.showEnableTeamOrder = true;
      } else {

      }
    },
    onClickTableNumber(num) {
      this.tableNumber = num;
    },
    onClickTableChildenNumber(num){
     this.tableChildenNumber = num
    },
    handleToOrderPage() {
      if(this.tableChildenNumber===0&&this.tableNumber==0){
          this.$toast( "请选择人数或者输入人数");
        return
      }
      if (
        this.PayMode == 2 &&
        (this.cardCode == undefined ||
          (!this.cardCode && this.cardCode.length == 0))
      ) {
        this.cardCode = "";
      }
       
      if(this.tableChildenNumber>100){
         this.$toast( "请选择人数或者输入有效人数");
        return
      }
      const deskObj = handleSessionStorage.get("deskCode");
      handleSessionStorage.set("deskCode", {
        ...deskObj,
        checkinId: "",
        cardCode: this.cardCode,
        PersonNum: this.tableNumber,
        ChildenNumber:this.tableChildenNumber,
        PayMode: this.PayMode,
      });
      this.$router.replace({
        name: "NewMicropoint",
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },

    handleGetVpnList() {
      const vpnStorage = handleSessionStorage.get("vpnInfo");
      $http(`wechath5/zh-cn/v1/vpn`).then((res) => {
        const vpnList = res.Items;
        if (vpnList.length == 0) {
          return;
        }
        let vpnItem = null;
        if (this.saasCode) {
          vpnItem = vpnList.find((item) => item.SaaSCode == this.saasCode);
        } else if (vpnStorage) {
          vpnItem = vpnList.find((item) => item.SaaSCode == vpnStorage.code);
        }
        if (!vpnItem) {
          vpnItem = vpnList[0];
        }
        if (vpnItem) {
          applyDevMockUseBlackGoldenUI(vpnItem);
          applyBlackGoldenUIVersion(vpnItem);
          setBlackOrderFlag(vpnItem.UseBlackGoldenUI);
          this.vpnInfo = vpnItem;
          this.queyDiningRoomList();
          this.redirectToBlackPeopleNumIfNeeded();
        }
      });
    },

    queyDiningRoomList() {
     this.vpnInfo = {
        name: this.vpnInfo.Name,
        code: this.vpnInfo.SaaSCode,
        id: this.vpnInfo.Id,
        ...this.vpnInfo.SaasVpnSetting,
      };
      this.KeyBindComponent =this.vpnInfo.KeyBindComponent?this.vpnInfo.KeyBindComponent:0,
      handleSessionStorage.set("vpnInfo", this.vpnInfo);
      getDiningRoomList({ vpnId: this.vpnInfo.id })
        .then((res) => {
          const item = res.find((mode) => mode.Id == this.diningRoomId);
          if (item == undefined) {
            this.diningRoomId = res[0].Id;
            handleSessionStorage.set("diningRoomId", res[0].Id);
            this.PayMode = res[0].PayMode;
          } else {
            this.PayMode = item.PayMode;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.check_person_con {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  padding-top: 26px;
  box-sizing: border-box;
  .person_title_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 53px;
    img {
      width: 158px;
      height: 158px;
      margin-bottom: 16px;
    }
  }
  .select_number_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: 32px 32px 0px 0px;
    flex: 1;
    padding: 48px 50px;
    .select_tips {
      margin: 64px 0 32px;
      position: relative;
      display: flex;
      align-items: center;
    }
  }
}
.table_number_con {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .table_number_item {
    padding: 14px 0;
    box-sizing: border-box;
    width: 22.5%;
    text-align: center;
    border: 1px solid #eaeaea;
    border-radius: 40px;
    color: #97A0A9;
    margin-right: 20px;
    margin-bottom: 20px;
    &.active_item {
      background: #e1edde;
      font-size: 36px;
      border: 1px solid rgba(132,157,128,0.4);
      color:#737A84;
    }

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.number_submit_btns {
  padding: 30px;
  width: 100%;
  margin-top: 24px;
}

.custom-button {
  color: #849d80 !important;
  font-weight: bold;
  font-size: 1rem !important;
}
.overlay_con_content {
  width: 100%;
  margin-left: 10px;
  margin-right: 10px;
  background-color: white;
  border-radius: 10px;
  align-items: center;
  color: #737a84;
  font-size: 37px;
}
.overlay_con_img {
  width: 48px;
  height: 48px;
  margin-top: 40px;
  margin-left: 48px;
}
.overlay_con_p {
  text-align: center;
  margin-top: 40px;
  height: 48px;
  line-height: 48px;
  color: #737a84;
  font-size: 34px;
  margin-left: 10px;
}
.cancel-custom-button {
  color: #97a0a9 !important;
  font-weight: bold;
  font-size: 1rem !important;
  background: white !important;
  border: 1px solid #eaeaea;
}
.keycode-title-class {
  text-align: center;
  width: 100%;
  color: #555c67;
  font-weight: 500;
}
.keycode-class {
  display: flex;
  width: 100%;
  margin-top: 12px;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
}
.keycode-input {
  background-color: white;
  height: 70px;
  flex: 1;
  color: #97A0A9;
  border: 1px solid #EAEAEA;
  border-radius: 40px;
  margin-top: 10px;
  padding-left: 20px;
}
.keycode-scan {
  width: 50px;
  height: 50px;
  margin-left: 20px;
  padding-top: 10px;
}
</style>
